import type { OperatorData } from './MetricRepository';

export default {
  toPacket: ({ offset, offsetMetrics }: OperatorData<'maxHeartRate'>) =>
    offsetMetrics.filter((_: number, i: number) => i <= offset).pop(),

  toValue: ({ offsetMetrics }: OperatorData<'maxHeartRate'>) =>
    offsetMetrics.reduce((acc: number, v: number) => acc + v, 0),
};
